import { HolidaysPanel } from '@/features/hr/components/LeaveSettings'

export default function HrHolidaysPage() {
  return <HolidaysPanel />
}
